import { ARWEAVE_GATEWAY_URL } from '../config';

const getArweaveContentUrl = (arweaveId: string) => `${ARWEAVE_GATEWAY_URL}/${arweaveId}`;

export default getArweaveContentUrl;
